import React, { Component } from 'react';
import { getCurrentLocale } from 'helpers/i18n';
import { languageMapping } from 'helpers/constants';
import { connect } from 'react-redux';
import { updateLanguage } from 'react-localize-redux';
import styled from 'styled-components';
import { colors as colorHelper } from 'helpers/ColorHelper';

const StyledLinkButton = styled.button`
  font-family: 'Circular';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: ${props => (props.img ? colorHelper.LIGHT_GRAY : colorHelper.ULTRAMARINE_BLUE)};

  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0 0 5px 0;
  padding: 0 10px 0 0;
  border-radius: 0px !important;

  &:hover {
    text-decoration: none;
    color: #a3c2ff !important;
  }

  &:focus {
    text-decoration: none;
  }
`;
const ButtonContainerStyled = styled.span`
  display: inline-block;
  margin: 0 20px;
`;

class LanguageOptionsBackground extends Component {
  handleLanguageChange = languageCode => {
    this.props.updateLanguage(languageCode);
    localStorage.setItem('locale', languageCode);
    this.forceUpdate();
  };

  render() {
    const { defaultLanguages, isAuthenticating, img } = this.props;
    if (!defaultLanguages || defaultLanguages.length === 0 || defaultLanguages.length === 1)
      return null;

    const currentLanguage = getCurrentLocale();

    const languages = defaultLanguages.map(language => {
      if (language !== currentLanguage) {
        return (
          <StyledLinkButton
            disabled={isAuthenticating}
            onClick={() => this.handleLanguageChange(language)}
            img={img}
          >
            {languageMapping[language]}
          </StyledLinkButton>
        );
      }

      return null;
    });

    return <ButtonContainerStyled>{languages}</ButtonContainerStyled>;
  }
}

let LanguageOptionsBackgroundConnected = connect(
  store => ({
    defaultLanguages: store.userTypes.defaultLanguages,
  }),
  { updateLanguage }
)(LanguageOptionsBackground);

export default LanguageOptionsBackgroundConnected;
